import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles.js';

const AddClientPage = lazy(() => import('./AddClientPage'));

const AddClientConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Sales,
  routes: [
    {
      path: 'clients/add',
      element: <AddClientPage />,
    },
  ],
};

export default AddClientConfig;
